import { EventItemInterface } from '../../../pages/ato/activity/ato-event/ato-threat-events-flow/AtoThreatEventsFlow.model';
import { OperatingSystems } from '../../values/values.service';
import { AtoProviders } from './AtoService.model';
import { InstagramPostModel } from './AtoInstagramPost.model';

export interface AtoEventModel {
    _id: string;
    event_target_id: string;
    event_type: EventTypes;
    identity_id: string;
    created_at: Date;
    event_metadata: any; //! nu stiu ce e aici
    resolved?: boolean;
    updated_at: Date;
    event_group: EventGroups;
    event_level: EventLevels;
    event_category: EventCategories;
    useful?: boolean;
    status?: EventStatus;
    viewed?: boolean;
    new?: boolean;
    provider?: AtoProviders;

    _computedClass: EventClass[];
    _computedLayout: EventInterfaceLayouts;
    _computedDate: string;
    _computedTime: string;
    _computedChannelName: string;
    _computedChannelHandle: string;
    _computedChannelId: string;
    _computedChannelUrl: string;
    _computedEventMediaUrl: string;
    _computedEventMediaUrls?: string[];
    _computedEventMetadataMainValue: string;
    _computedVisibility: boolean;
    _computedThreatCategory?: ThreatEventCategory;
    _computedThreatSubcategory?: ThreatEventSubcategory;
    _computedThreatCategoryInterface?: CategoryInterface;
    _computedThreatType: EventThreatType;
    _computedThreatSubtype: EventThreatSubtype;
    _computedThreatDetails?: any[];
    _computedCardState: EventCardState;
    _computedIsAto: boolean;
    _computedIsRestored: boolean;
    _computedPlaceholders?: Placeholders;
}

export interface Placeholders {
    manufacturerName?: string;
    value?: string;
    inbox?: string;
    username?: string;
    name?: string;
    oldName?: string;
    newName?: string;
    oldNdame?: string;
    oldUsername?: string;
    newUsername?: string;
    bio?: string;
    channelType?: string;
    accountNameAndHandle?: string;
    email?: string;
    phoneNumber?: string;
    oldStatus?: string;
    status?: string;
    dangerousLink?: string;
    time?: string;
}

export interface IgNewPostEvent extends AtoEventModel {
    event_type: EventTypes.IG_NEW_POST;
    event_metadata: InstagramPostModel;
}

export interface IgNewReelEvent extends AtoEventModel {
    event_type: EventTypes.IG_NEW_REEL;
    event_metadata: InstagramPostModel;
}

export enum EventClass {
    ACCOUNT_HEALTH = 'accountHealth',
    DEVICE_PROTECTION = 'deviceProtection',
    SCAM_GUARD = 'scamGuard',
    TEAM_SHIELD = 'teamShield',
    GUIDED_RECOVERY = 'guidedRecovery',
    PREVENTIVE_ACTIONS = 'preventiveActions'
}

export enum EventInterfaceLayouts {
    MONITORED_VIDEOS = 'monitoredVideos',
    MONITORED_POSTS = 'monitoredPosts',
    CONNECTED_ACCOUNT = 'connectedAccount',
    NORMAL = 'normal',
    MEDIA_PREVIEW = 'mediaPreview',
    RECOMMENDATIONS = 'recommendations',
    INBOX_SCAN = 'inbox_scan',
    THREATS = 'threats',
    SUSPICIOUS_MESSAGE = 'suspicious_message',
}

export enum EventGroups {
    PINNED = 'pinned',
    TIMELINE = 'timeline'
}

export enum EventLevels {
    CRITICAL = 'critical',
    THREAT = 'threat',
    RECOMENDATION = 'recommendation',
    STATS = 'stats'
}

export enum EventCategories {
    ACCOUNT_MONITORING = 'account_monitoring',
    DEVICE_PROTECTION = 'device_protection',
    SCAM_PROTECTION = 'scam_protection',
    TEAM_PROTECTION = 'team_protection',
    RECOVERY = 'recovery'
}

export enum EventTargets {
    SERVICE = 'service',
    DEVICE = 'device',
    WEBMAIL = 'webmail'
}

export enum EventStatus {
    DONE = 'done',
    POSTPONE = 'postpone',
    FALSE_POSITIVE = 'false_positive'
}

export enum ThreatEventCategory {
    FILE = 'file',
    APP = 'app',
    URL = 'url',
    BEHAVIOUR = 'behaviour',
    MOBILE = 'mobile',
    HOST = 'host'
}

export enum ThreatEventSubcategory {
    DEFAULT = 'default',
    WITH_RCA = 'withRca'
}

export enum EventTypes {
    // Youtube scanner events
    SERVICE_ACCOUNT_CONNECTED = 'service_account_connected',
    SERVICE_ACCOUNT_UPDATED ='service_account_updated',
    MONITORED_VIDEOS_NUM = 'monitored_videos_num',
    NEW_VIDEO = 'new_video',
    VIDEO_STATUS_CHANGED = 'video_status_changed',
    NEW_BANNER = 'new_banner',
    NEW_PROFILE_PICTURE = 'new_profile_picture',
    NEW_CHANNEL_DESCRIPTION = 'new_channel_description',
    NEW_PLAYLIST = 'new_playlist',
    VIDEO_DELETED = 'video_deleted',
    PLAYLIST_DELETED = 'playlist_deleted',
    // Youtube pinned events
    ACCOUNT_TAKEOVER = 'account_takeover',
    DISCONNECTED_API = 'disconnected_api',
    ACCOUNT_RESTORED = 'account_restored',
    // Youtube recommendation events
    REVIEW_AUTHORIZED_MEMBERS = 'review_authorized_members',
    REVIEW_3RD_PARTY_APPS = 'review_3rd_party_apps',
    REVIEW_RECOVERY_OPTIONS = 'review_recovery_options',
    REGULARLY_CHANGE_PASSWORD = 'regularly_change_password',
    REVIEW_YOUR_DEVICES = 'review_your_devices',

    // Webmail events Pinned
    ACTIVATE_WEBMAIL_PROTECTION = 'activate_webmailprotection',
    WEBMAIL_PROTECTION_DISCONNECTED = 'webmailprotection_disconnected',
    // Webmail events Timeline
    WEBMAIL_PROTECTION_ACTIVATED = 'webmailprotection_activated',
    WEBMAIL_PROTECTION_DAILY_INBOX_SCAN = 'webmailprotection_dailyinboxscan', // new?
    WEBMAIL_PROTECTION_INBOX_SCAN = 'webmailprotection_inboxscan',

    // Devices events timeline
    SUCCESSFULLY_INSTALLED_TS_ON_DEVICE = 'successfully_installed_ts_on_device',
    SECURITY_CENTER_THREAT_EVENT = 'security_center_threat_event',
    //Devices events pinned
    INSTALL_TS_ON_ANOTHER_DEVICE = 'install_ts_on_another_device',
    DEVICE_RISK_SHIELD_OFF = 'device_risk_shield_off',
    DEVICE_RISK_WEB_ATTACK_PREVENTION_OFF = 'device_risk_web_attack_prevention_off',
    DEVICE_RISK_ADT_OFF = 'device_risk_adt_off',
    DEVICE_DISCONNECTED = 'device_disconnected',
    MALICIOUS_FILE_DETECTED = 'malicious_file_detected',
    FINISH_TS_INSTALLATION = 'finish_ts_installation',

    // Instagram scanner events
    IG_SERVICE_ACCOUNT_CONNECTED = 'ig_service_account_connected',
    IG_MONITORED_POSTS_NUM = 'ig_monitored_posts_num',
    IG_NEW_POST = 'ig_new_post',
    IG_PROFILE_PHOTO_CHANGED = 'ig_profile_photo_changed',
    IG_NAME_CHANGED = 'ig_name_changed',
    IG_USERNAME_CHANGED = 'ig_username_changed',
    IG_NEW_BIOGRAPHY = 'ig_new_biography',
    IG_POST_DELETED = 'ig_post_deleted',
    IG_POST_CHANGED = 'ig_post_changed',
    // IG_NEW_STORY = 'ig_new_story', // not implemented in this version
    IG_NEW_REEL = 'ig_new_reel',
    IG_REEL_DELETED = 'ig_reel_deleted',
    IG_REEL_CHANGED = 'ig_reel_changed',
    IG_SUSPICIOUS_MESSAGE = 'ig_suspicious_message',

    // Instagram pinned events
    IG_ACCOUNT_TAKEOVER = 'ig_account_takeover',
    IG_ACCOUNT_RESTORED = 'ig_account_restored',
    IG_DISCONNECTED_API = 'ig_disconnected_api',

    // Instagram recommendation events
    IG_REVIEW_3RD_PARTY_APPS = 'ig_review_3rd_party_apps',
    IG_REVIEW_RECOVERY_OPTIONS = 'ig_review_recovery_options',
    IG_REGULARLY_CHANGE_PASSWORD = 'ig_regularly_change_password',
    IG_REVIEW_YOUR_DEVICES = 'ig_review_your_devices',

    // Facebook scanner events
    FB_SERVICE_ACCOUNT_CONNECTED = 'fb_service_account_connected',
    FB_SERVICE_ACCOUNT_UPDATED = 'fb_service_account_updated',
    FB_MONITORED_POSTS_NUM = 'fb_monitored_posts_num',
    FB_NEW_POST = 'fb_new_post',
    FB_PROFILE_PHOTO_CHANGED = 'fb_profile_photo_changed',
    FB_COVER_PHOTO_CHANGED = 'fb_cover_photo_changed',
    FB_NAME_CHANGED = 'fb_name_changed',
    FB_USERNAME_CHANGED = 'fb_username_changed',
    FB_EMAIL_CHANGED = 'fb_email_changed',
    FB_PHONE_NUMBER_CHANGED = 'fb_phone_number_changed',
    FB_NEW_BIOGRAPHY = 'fb_new_biography',
    FB_NEW_ALBUM = 'fb_new_album',
    FB_POST_DELETED = 'fb_post_deleted',
    FB_ALBUM_DELETED = 'fb_album_deleted',
    FB_POST_CHANGED = 'fb_post_changed',
    FB_ROLES_CHANGED = 'fb_roles_changed',
    FB_ROLES_CHANGED_REMOVED = 'fb_roles_changed_removed',
    FB_SUSPICIOUS_MESSAGE = 'fb_suspicious_message',
    FB_NEW_REEL = 'fb_new_reel',
    FB_REEL_DELETED = 'fb_reel_deleted',

    // Facebook pinned events
    FB_ACCOUNT_TAKEOVER = 'fb_account_takeover',
    FB_ACCOUNT_RESTORED = 'fb_account_restored',
    FB_DISCONNECTED_API = 'fb_disconnected_api',

    // Facebook recommendation events
    FB_REVIEW_AUTHORIZED_MEMBERS = 'fb_review_authorized_members',
    FB_REVIEW_3RD_PARTY_APPS = 'fb_review_3rd_party_apps',
    FB_REVIEW_RECOVERY_OPTIONS = 'fb_review_recovery_options',
    FB_REGULARLY_CHANGE_PASSWORD = 'fb_regularly_change_password',
    FB_REVIEW_YOUR_DEVICES = 'fb_review_your_devices',

    // Other events
    MONITORING_STARTED = 'monitoring_started',
    ADD_SMS_METHOD_OF_CONTACT = 'add_sms_method_of_contact',
    TEAM_INVITE = 'invite_team_members',
}

export interface EventTypeIconInterface {
    type: string;
    icon: string;
    bgColor?: string;
    color?: string;
}

export interface EventTypeInterface {
    /**
     * Icon that will be displayed in the event card.
     * Mutually exclusive with `avatar` property.
     */
    icon?: EventTypeIconInterface;

    /**
     * Avatar that will be displayed in the event card. If true will use the avatar from the parent service.
     * Mutually exclusive with `icon` property.
     */
    avatar?: boolean;
    title?: string;
    desc?: string;
    descNoEmail?: string;
    descSafe?: string;
    descSafeNoEmail?: string;
    one?: EventTypeInterface;
    empty?: EventTypeInterface;
    actionButton?: {
        text?: string,
        link?: string
    };
}

export type EventsTypeInterface = {
    [key in EventTypes]? : EventTypeInterface;
};

export interface EventClassInterface {
    type: string;
    icon: string
    label: string;
}

export type EventsClassInterface = {
    [key in EventClass]? : EventClassInterface
};

export type EventInfoModel = {
    [key in EventTypes]? : {
        event_type: EventTypes,
        event_group: EventGroups,
        event_level: EventLevels,
        event_category: EventCategories,
        event_target?: EventTargets,
        skip_insert?: boolean
    }
};

export interface ExplainableThreatInterface {
    event_id: string;
    priority: number;
    group_id: string;
    group_name: string;
    name: string;
    description: string;
}

export enum AccountTakeoverEventReasons {
    VIDEOS_DELETED = 'percent_videos_deleted',
    PLAYLISTS_DELETED = 'percent_playlists_deleted',
    HANDLE_CHANGED = 'handle_changed',
    AVATAR_CHANGED = 'avatar_changed',
    BANNER_CHANGED = 'banner_changed',
    MALICIOUS_AVATAR = 'malicious_avatar',
    MALICIOUS_VIDEO_THUMBNAIL = 'malicious_video_thumbnail',
    MALICIOUS_VIDEO_TITLE = 'malicious_video_title',
    MALICIOUS_VIDEO_DESC = 'malicious_video_description',
    MALICIOUS_CHANNEL_NAME = 'malicious_channel_name',
    MALICIOUS_BANNER = 'malicious_banner',
    DESCRIPTION_REMOVED = 'description_removed',
    DESCRIPTION_CHANGED = 'description_changed',
    CHANNEL_NAME_CHANGED = 'channel_name_changed',

    USERNAME_CHANGED = 'username_changed',
    NAME_CHANGED = 'name_changed',
    BIOGRAPHY_CHANGED = 'biography_changed',
    PHONE_NUMBER_CHANGED = 'phone_number_changed',
    EMAILS_CHANGED = 'emails_changed',
    // ROLES_CHANGED = 'roles_changed',
    PROFILE_PICTURE_CHANGED = 'profile_picture_changed',
    PROFILE_PICTURE_REMOVED = 'profile_picture_removed',
    PROFILE_PICTURE_ADDED = 'profile_picture_added',
    IS_PROFILE_PICTURE_MALICIOUS = 'is_profile_picture_malicious',
    COVER_PICTURE_CHANGED = 'cover_picture_changed',
    COVER_PICTURE_REMOVED = 'cover_picture_removed',
    COVER_PICTURE_ADDED = 'cover_picture_added',
    IS_COVER_PICTURE_MALICIOUS = 'is_cover_picture_malicious',
    POSTS_PERCENT_REMOVED = 'posts_percent_removed',
    POSTS_PERCENT_ADDED = 'posts_percent_added',
    ALBUMS_PERCENT_REMOVED = 'albums_percent_removed',
    ALBUMS_PERCENT_ADDED = 'albums_percent_added',

    WEBSITE_CHANGED= 'website_changed',
    POSTS_AND_REELS_PERCENT_REMOVED= 'posts_and_reels_percent_removed',
    POSTS_AND_REELS_PERCENT_ADDED= 'posts_and_reels_percent_added',
}

export enum TakeoverRegionsType {
    WHAT_HAPPENED = 'whatHappened',
    ACCESS_ACOUNT = 'accessAccount',
    RESET_PASSWORD = 'resetPassword',
    REVIEW_SETTINGS = 'reviewSettings',
    CHECK_RECOVERY_INFO = 'checkRecoveryInfo'
}

export enum TakevoverStepCardType {
    RECONNECT_APPLY = "reconnect-apply", // general
    MANUAL_FIX = "manual-fix", // action
    BOOKMARK = "bookmark", // feedback
    TWOFA = "2fa", // user-data
    PASSWORD = "password", // user-data
    DEVICES = "devices", // generic
    ADVICE = "advice", // generic
    PROFILING_TARGETING = "profiling-targeting", // feature
}

export enum BlockedState {
    BLOCKED = 1,
    NOT_BLOCKED = 0
}

export enum ObjectType {
    FILE = 'file',
    APP = 'app',
    BEHAVIOUR = 'behaviour',
    URL = 'url',
    HOST = 'host'
}

export enum EventThreatType {
    MALWARE = 'malware',
    FRAUD = 'fraud',
    TROJAN = 'trojan',
    ATTACK = 'attack',
    RANSOMWARE = 'ransomware',
    EXPLOIT = 'exploit',
    VIRUS = 'virus',
    PHISHING = 'phishing',
    UNTRUSTED = 'untrusted',
    SPAM = 'spam',
    MINER = 'miner',
    MINER_SERVER = 'miner-server',
    PUA = 'pua',
    CERTIFICATE = 'certificate',
    PRIVACY = 'privacy',
    BOT = 'bot',
    SAV_CRYPTO = 'sav_crypto',
    MALICIOUS_HOST = 'malicious_host',
    DEFAULT = 'default'
}

export enum EventThreatSubtype {
    CMD = 'cmd',
    PROCESS_MEMORY_SCAN = 'process_memory_scan',
    SCANNING = 'scanning',
    GENERIC = 'generic',
    BRUTEFORCE = 'bruteforce',
    BRUTEFORCE_HTTP = 'bruteforce_http',
    EXPLOIT = 'exploit',
    CERTIFICATE_INVALID_SIGNATURE = 'certificate_invalid_signature',
    CERTIFICATE_REVOKED = 'certificate_revoked',
    CERTIFICATE_EXPIRED = 'certificate_expired',
    CERTIFICATE_WRONG_HOST = 'certificate_wrong_host',
    UNTRUSTED_ROOT = 'untrusted_root',
    DATA = 'data',
    BANKING = 'banking',
    PASSWORD = 'password',
    LOGIN = 'login',
    LFI = 'lfi',
    MALWARE = 'malware',
    FRAUD = 'fraud',
    PHISHING = 'phishing',
    MINER = 'miner',
    PUA = 'pua',
    MALVERTISING = 'malvertising',
    SPAM = 'spam',
    UNTRUSTED = 'untrusted',
    DEFAULT = 'default',
}

export enum VideoStatuses {
    PUBLIC = 'public',
    PRIVATE = 'private',
    UNLISTED = 'unlisted'
}

export interface TheatModel {
    blocked: BlockedState;
    object: string;
    object_type: ObjectType;
    rca_id: string;
    threat: string;
    threat_subtype: EventThreatSubtype;
    threat_type: EventThreatType;
    timestamp: Date;
}

export interface RcaEventReportModel extends TheatModel {
    detection_module: string;
    report_id: string;
}

export interface RcaEventDataModel {
    name: string;
    signed: boolean;
    signed_by: string;
}

export interface RcaTimelineActionModel {
    child: RcaEventDataModel;
    parent: RcaEventDataModel;
    timestamp: Date;
    type: string;
}

export interface RcaTimelineModel {
    events: RcaEventModel[];
    priority_attack: string;
}

export interface RcaEventModel {
    threat_type: EventThreatType;
    threat: TheatModel;
    rca_id: string;
    display_name: string;
    device_os: OperatingSystems;
    device_type: string;
    rca_event: {
        report: RcaEventReportModel;
        timeline: RcaTimelineActionModel[];
    }
}

export interface CategoryInterface {
    bgColor?: string;
    texts?: {
        [key in EventThreatType]?: {
            [key in EventThreatSubtype]?: {
                firstNodeTitle?: string;
                title: string;
                desc: string;
                avertedOutcome: string;
            }
        }
    }
}

export type ThreatEventCategoryInterface =  {
    [key in ThreatEventCategory]?: CategoryInterface;
};

export type ThreatEventsInterface = {
    [key in ThreatEventCategory]?: {
        default?: {
            firstNode: EventItemInterface,
            itemNode: EventItemInterface,
            lastGoodNode: EventItemInterface,
            lastBadNode: EventItemInterface
        },
        withRca?: {
            firstNode: EventItemInterface,
            itemNode: EventItemInterface,
            lastGoodNode: EventItemInterface,
            lastBadNode: EventItemInterface
        }
    }
};

export enum ExplainableThreatsCodes {
    SPYING_ACTIVITIES = '001',
    DEVICE_CONTROL = '002',
    DEFENSIVE_EVASION = '003',
    HIDING_FROM_USER = '004',
    PHISHING_ATTEMPT = '005',
    MONEY_EXTORTION = '006',
    SPREADING = '007',
    NETWORK_ACTIVITIES = '008',
    BITDEFENDER_VERDICT = '009',
    APPLICATION_DETAILS = '010',
    FINANCIAL_RISK = '011',
    ADWARE_ACTIVITIES = '012'
}

export type IExplainableThreatsDetails = {
    [group_id in ExplainableThreatsCodes]: {
        icon: {type: string; icon: string;}
    }
};

export enum EventCardState {
    NEUTRAL = 'state-neutral',
    DANGER = 'state-danger',
    RECOMANDATION = 'state-recomandation',
    SUCCESS = 'state-success'
}

export type VideoStatusesInterface = {
    [key in VideoStatuses]?: {
        statusIcon: {type: string; icon: string;},
        statusEmoji: string,
        label: string
    }
};

export const SecondOnboardingEventsSet = new Set([
    EventTypes.FINISH_TS_INSTALLATION,
    EventTypes.ACTIVATE_WEBMAIL_PROTECTION,
    EventTypes.TEAM_INVITE
]);

export const ServiceConnectedEventsSet = new Set([
    EventTypes.SERVICE_ACCOUNT_CONNECTED,
    EventTypes.IG_SERVICE_ACCOUNT_CONNECTED,
    EventTypes.FB_SERVICE_ACCOUNT_CONNECTED
]);

export const MonitoredPostsEventsSet = new Set([
    EventTypes.MONITORED_VIDEOS_NUM,
    EventTypes.IG_MONITORED_POSTS_NUM,
    EventTypes.FB_MONITORED_POSTS_NUM
]);

export enum GroupedRecommendationsKeys {
    REGULARLY_CHANGE_PASSWORD = 'regularly_change_password',
    REVIEW_3RD_PARTY_APPS = 'review_3rd_party_apps',
    REVIEW_YOUR_DEVICES = 'review_your_devices',
    REVIEW_AUTHORIZED_MEMBERS = 'review_authorized_members',
    REVIEW_RECOVERY_OPTIONS = 'review_recovery_options'
}


export type GroupedRecommendationsMap = {
    [key in GroupedRecommendationsKeys]?: EventTypes[]
};

export interface RecommendationGroup {
    key: GroupedRecommendationsKeys;
    eventsByProvider: {
      [key in AtoProviders]?: AtoEventModel[];
    };
    interface?: EventTypeInterface;
}

export interface SingleRecommendation {
    event?: AtoEventModel;
    interface?: EventTypeInterface;
}

export interface RecommendationsByChannel {
    [channel: string]: SingleRecommendation[];
}

export interface AllRecommendations {
    grouped: RecommendationGroup[]; // grouped by recommendation key and provider
    general: SingleRecommendation[]; // without service_id
    byProvider: RecommendationsByChannel; // service_id-based events
}
